module.exports = __webpack_public_path__ + "b7a26a27ceeeee46ac1cf99315b37bd0.png";